const diseases =
{
    helmet :
    {
        title : 'Maladies' ,
        metas : []
    }
};

export default diseases ;